import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { useMergeRefs } from 'use-callback-ref';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Truncate as Truncate$1 } from './Truncate.styled.es.js';
import { useTruncate } from './useTruncate.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Truncate = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      _a$as = _a.as,
      as = _a$as === void 0 ? "div" : _a$as,
      _a$mode = _a.mode,
      mode = _a$mode === void 0 ? "end" : _a$mode,
      ellipsis = _a.ellipsis,
      _a$nbOfLines = _a.nbOfLines,
      nbOfLinesProp = _a$nbOfLines === void 0 ? 1 : _a$nbOfLines,
      rest = __objRest(_a, ["children", "as", "mode", "ellipsis", "nbOfLines"]);

  var nbOfLines = mode === "middle" ? null : nbOfLinesProp;

  var _useTruncate = useTruncate({
    mode: mode,
    ellipsis: ellipsis
  }),
      containerRef = _useTruncate.containerRef,
      isReady = _useTruncate.isReady;

  var mergedRefs = useMergeRefs([ref, containerRef]);
  var title = typeof children === "string" ? children : null;
  return (
    /* @__PURE__ */
    React.createElement(Truncate$1, __spreadValues({
      as: as,
      ref: mergedRefs,
      title: title,
      mode: mode,
      nbOfLines: nbOfLines
    }, rest),
    /* @__PURE__ */
    React.createElement("span", {
      style: {
        opacity: isReady ? 1 : 0
      }
    }, children))
  );
});
Truncate.displayName = "Truncate";
export { Truncate };